import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ErrorIcon from "@mui/icons-material/Error";
import { IconButton } from "@mui/material";
import PropTypes from "prop-types";

//import Components
import Tooltip from "Components/Common/Tooltip";
import LanguageDropdown from "../Components/Common/LanguageDropdown";
import NotificationDrawer from "Components/NotificationDrawer";
import ProfileDropdown from "../Components/Common/ProfileDropdown";
import LightDark from "../Components/Common/LightDark";
import {
  allAdminRoles,
  CONSUMER,
  fireSafetyRoles,
  SUPER_ADMIN,
} from "common/constant";
import { adminActivityLogRoute } from "Routes/constants";
import { isAuthorizedUser } from "utils";

const Header = ({ onChangeLayoutMode, layoutModeType }) => {
  const { roles } = useSelector((state) => state.Login);
  const navigate = useNavigate();

  return (
    <>
      <div className="d-flex align-items-center">
        {/* LanguageDropdown */}
        <LanguageDropdown />

        {roles.includes(SUPER_ADMIN) && (
          <Tooltip title="Event Logs">
            <IconButton onClick={() => navigate(adminActivityLogRoute)}>
              <ErrorIcon sx={{ color: "#fff" }} />
            </IconButton>
          </Tooltip>
        )}

        {/* Dark/Light Mode set */}
        <LightDark
          layoutMode={layoutModeType}
          onChangeLayoutMode={onChangeLayoutMode}
        />
        {/* NotificationDropdown */}
        {isAuthorizedUser(roles, [
          ...allAdminRoles,
          ...fireSafetyRoles,
          CONSUMER,
        ]) && <NotificationDrawer />}
        {/* ProfileDropdown */}
        <ProfileDropdown />
      </div>
    </>
  );
};

Header.propTypes = {
  onChangeLayoutMode: PropTypes.func,
  layoutModeType: PropTypes.string,
};

export default Header;
